var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React from 'react';
import t from 'prop-types';
import * as Util from '../util';

function BotonPulsador(props) {
  function handlePresionado(e) {
    e.preventDefault();
    e.stopPropagation();
    var id = props.id,
        grupo = props.grupo,
        onPresionado = props.onPresionado;
    onPresionado && onPresionado(id, grupo, !presionado);
  }

  var eventHandlers = Util.is_touch_device() ? {
    onTouchEnd: handlePresionado
  } : {
    onClick: handlePresionado
  };
  var id = props.id,
      presionado = props.presionado;
  var clases = ['botonHerramienta', presionado ? 'activa' : ''].join(' ');
  return React.createElement('div', _extends({
    id: 'herramienta' + id,
    className: clases
  }, eventHandlers));
}

BotonPulsador.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Identificador del boton */
  id: t.string.isRequired,

  /** Grupo de la barra de herramientas al que pertenece el boton */
  grupo: t.string.isRequired,

  /** Indica si el boton esta presionado o no */
  presionado: t.bool,
  onPresionado: t.func
} : {};
export default BotonPulsador;